:host {
  display: grid;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}